export default __webpack_public_path__ + "static/media/bedside-table.8cbc4b90.png";